export const FILE_MAX_SIZE = 3; //size in mb